<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <!--  PART ONE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="masterData.plan_master?.plan_name_th ? true : false"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                แผนงาน
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <div>{{ masterData.plan_master?.plan_name_th }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="!!partOneForm.project_name_th"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อโครงการ
                <div>(ภาษาไทย)</div>
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <div>{{ partOneForm.project_name_th }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="!!partOneForm.project_name_en"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ชื่อโครงการ
                <div>(ภาษาอังกฤษ)</div>
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <div>{{ partOneForm.project_name_en }}</div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="!!partOneForm.reference_reg"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                อ้างอิง
                <div>(Requirement Form)</div>
              </div>
              <div>{{ partOneForm.reference_reg }}</div>
            </div>
          </div>

        </div>

      </div>
    </divcard>


    <!--  PART TWO  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('one')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              1. ข้อมูลหัวหน้าโครงการและคณะผู้เชี่ยวชาญ
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 1 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ชื่อ - สกุล
                </div>
                <div>{{ partTwoForm.s2_p1_name }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ตำเเหน่ง
                </div>
                <div>{{ partTwoForm.s2_p1_position }}</div>
              </div>
            </div>

            <!-- Form 1 #line2 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  หน่วยงาน
                </div>
                <div>{{ partTwoForm.s2_p1_dep }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  สังกัด
                </div>
                <div>{{ partTwoForm.s2_p1_org }}</div>
              </div>
            </div>

            <!-- Form 1 #line3 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ที่อยู่
                </div>
                <div>{{ partTwoForm.s2_p1_addr }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  เบอร์โทรศัพท์
                </div>
                <div>{{ partTwoForm.s2_p1_phone }}</div>
              </div>
            </div>

            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  E-mail
                </div>
                <div>{{ partTwoForm.s2_p1_email }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ความเชี่ยวชาญ
                </div>
                <div>{{ partTwoForm.s2_p1_expertise }}</div>
              </div>
            </div>

            <!-- Form 1 #line4 -->
            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ความรับผิดชอบต่อโครงการที่เสนอ
              </div>
              <div>{{ partTwoForm.s2_p1_resp }}</div>
            </div>
          </div>

        </div>

      </div>

      <div class="card-part">
        <!-- Form 2 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('two')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              2. ผู้รับผิดชอบโครงการ (ภาคเอกชน)
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 2 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ชื่อ - สกุล
                </div>
                <div>{{ partTwoForm.s2_p2_pm_name }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ตำเเหน่ง
                </div>
                <div>{{ partTwoForm.s2_p2_pm_position }}</div>
              </div>
            </div>

            <!-- Form 2 #line2 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  เบอร์โทรศัพท์
                </div>
                <div>{{ partTwoForm.s2_p2_pm_phone }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  E-mail
                </div>
                <div>{{ partTwoForm.s2_p2_pm_email }}</div>
              </div>
            </div>

            <div class="font-type-bold black--text mb-3">ข้อมูลประสานงานโครงการ</div>

            <!-- Form 2 #line3 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ชื่อ - สกุล
                </div>
                <div>{{ partTwoForm.s2_p2_proj_coord_name }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ตำเเหน่ง
                </div>
                <div>{{ partTwoForm.s2_p2_proj_coord_position }}</div>
              </div>
            </div>

            <!-- Form 2 #line4 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  เบอร์โทรศัพท์
                </div>
                <div>{{ partTwoForm.s2_p2_proj_coord_phone }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  E-mail
                </div>
                <div>{{ partTwoForm.s2_p2_proj_coord_email }}</div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <div class="card-part">
        <!-- Form 3 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('three')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              3. ข้อมูลภาคเอกชนที่เข้าร่วมโครงการ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 2 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ชื่อ - สกุล นิติบุคคล/กิจการ
                </div>
                <div>{{ partTwoForm.s2_p3_prv_org_name }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ที่อยู่
                </div>
                <div>{{ partTwoForm.s2_p3_prv_org_address }}</div>
              </div>
            </div>

            <!-- Form 2 #line2 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  เบอร์โทรศัพท์
                </div>
                <div>{{ partTwoForm.s2_p3_prv_org_phone }}</div>
              </div>
              <div class="flex xs6 d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  E-mail
                </div>
                <div>{{ partTwoForm.s2_p3_prv_org_email }}</div>
              </div>
            </div>

            <!-- Form 2 #line3 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  รูปแบบของธุรกิจ/ลักษณะกิจการ (แบบย่อ)
                  <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
                </div>
                <div class="pl-10">{{ partTwoForm.s2_p3_prv_org_type }}</div>
              </div>
            </div>

            <!-- Form 2 #line4 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ระบุแนวโน้มที่บริษัทจะเป็นผู้เช่าพื้นที่ในอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต
                  <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p3_prv_org_trend?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>

            <!-- Form 2 #line5 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-3 black--text">
                  สัดส่วนการลงทุนของเอกชนในการร่วมโครงการ
                  <span class="theme-color-seven txt-normal">(ข้อมูลมาจากส่วนที่3)</span>
                </div>

                <div>
                  <ul>
                    <li>
                      <div class="d-flex justify-space-between" style="gap: 16px">
                        <div class="black--text pt-2">ภาคเอกชนสนับสนุนจำนวน</div>
                        <div class="d-flex justify-end" style="gap: 16px">
                          <div class="pt-2">{{ formatNumber(private_sum,2) }}</div>
                          <div class="black--text pt-2">บาท</div>
                          <div class="black--text pt-2" style="min-width: 80px; max-width: 80px">โดยแบ่งเป็น</div>
                          <div style="min-width: 200px; max-width: 200px"></div>
                        </div>
                      </div>

                      <ul style="list-style: none">
                        <li>
                          <div class="d-flex justify-space-between" style="gap: 16px">
                            <div class="pt-2">ส่วนที่เป็นตัวเงิน(In-cash)จำนวน</div>
                            <div class="pt-2 d-flex justify-end" style="gap: 16px">
                              <div class="pt-2">{{ formatNumber(incash_sum,2) }}</div>
                              <div class="pt-2">บาท</div>
                              <div class="pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                              <div class="pt-2">{{ incash_percent }}</div>
                              <div style="min-width: 200px; max-width: 200px"></div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="d-flex justify-space-between" style="gap: 16px">
                            <div class="pt-2">ส่วนที่เป็นสิ่งของสนับสนุน(In-Kind)จำนวน</div>
                            <div class="pt-2 d-flex justify-end" style="gap: 16px">
                              <div class="pt-2">{{ formatNumber(inkind_sum,2) }}</div>
                              <div class="pt-2">บาท</div>
                              <div class="pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                              <div class="pt-2">{{ inkind_percent }}</div>
                              <div style="min-width: 200px; max-width: 200px"></div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <div class="d-flex justify-space-between" style="gap: 16px">
                        <div class="black--text pt-2">อุทยานวิทยาศาสตร์ฯ สนับสนุนจำนวน</div>
                        <div class="d-flex justify-end" style="gap: 16px">
                          <div class="pt-2">{{ formatNumber(scipark_sum,2) }}</div>
                          <div class="black--text pt-2">บาท</div>
                          <div class="black--text pt-2" style="min-width: 80px; max-width: 80px">คิดเป็นร้อยละ</div>
                          <div class="pt-2">{{ scipark_percent }}</div>
                          <div style="min-width: 200px; max-width: 200px"></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>

      <div v-if="!isFinal" class="card-part">
          <!-- Form 4 -->
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                  v-if="!$route.query.preview"
                  :is-correct="partTwoValidate('four')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">
                4. กิจการของภาคเอกชนที่เข้าร่วมโครงการมีความเกี่ยวข้องในกลุ่มอุตสาหกรรม
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 4 #line1 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div v-html="partTwoForm.s2_p4_prv_org_involved ? partTwoForm.s2_p4_prv_org_involved.join(', <br>') : ''"></div>
                </div>
              </div>
              <!-- Form 4 #line2 -->
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div><b>ระบุเพิ่มเติม:</b> {{ partTwoForm.s2_p4_prv_org_other ? partTwoForm.s2_p4_prv_org_other : '-' }}</div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <!-- Form 5 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('five')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              5. กิจการของภาคเอกชน ได้รับการแก้ไขปัญหาด้านใดจากการเข้าร่วมโครงการ
              <div class="theme-color-seven txt-normal">
                อธิบายในหัวข้อที่ตรงกับกิจการของภาคเอกชนที่ได้รับการแก้ไขปัญหา (ตอบได้มากกว่า 1 ข้อ)
              </div>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 5 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  พัฒนาคุณภาพสินค้าให้ได้มาตรฐาน
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p5_prv_org_impr_product_quality?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <!-- Form 5 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การแก้ไขปัญหาของกระบวนการผลิต
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p5_prv_org_impr_process_issue?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>

            <!-- Form 5 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การปรับปรุงประสิทธิภาพกระบวนการผลิต
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p5_prv_org_impr_process_eff?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>

            <!-- Form 5 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การพัฒนาผลิตภัณฑ์ใหม่
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p5_prv_org_impr_new_product?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <!-- Form 6 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('six')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              6. ระบุปัญหาหรือความต้องการของภาคเอกชน
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 6 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_p6_prv_org_issue_desc?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <!-- Form 7 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('seven')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              7. ใช้นวัตกรรมอะไร เทคโนโลยี การพัฒนา ในด้านไหนเข้ามาช่วยในการแก้ปัญหาให้กับภาคเอกชน
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 7 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_p7_inno_desc?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <!-- Form 8 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('eight')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              8. ศักยภาพและความพร้อมในการดำเนินโครงการของภาคเอกชน
              <span class="theme-color-seven txt-normal">(โปรดกรอกข้อมูลให้ครบทุกข้อ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 8 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ศักยภาพความพร้อมในการทำงานวิจัยและพัฒนา
                </div>
              </div>
            </div>
            <!-- Form 8 #line2 -->
            <div class="flex-center gap-16 pl-10">
              <div class="flex">
                <div class="mb-1 black--text">
                  มีความรู้พื้นฐานด้านเทคโนโลยีที่ เกี่ยวข้องกับผลิตภัณฑ์และกระบวนการ
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p8_prv_org_project_readiness?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <!-- Form 8 #line3 -->
            <div class="flex-center gap-16 pl-10">
              <div class="flex">
                <div class="mb-1 black--text">
                  ความพร้อมด้านอุปกรณ์ เครื่องมือ ในการทำงานวิจัย
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p8_prv_org_rnd_readiness?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>

          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 8 #line4 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ความพร้อมด้านการเงิน
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p8_prv_org_financial_readiness?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 8 #line4 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  การบริหารจัดการองค์กรและบุคลากร
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p8_prv_org_mgmt_readiness?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <!-- Form 9 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('nine')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              9. ศักยภาพและความพร้อมในการดำเนินโครงการ
              <div class="theme-color-seven txt-normal">
                (โปรดกรอกข้อมูลให้ครบทุกข้อ)
              </div>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 9 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ความพร้อมของบุคลากรและผู้เชี่ยวชาญ ประสบการณ์การทำงานร่วมกับภาคอุตสาหกรรม
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p9_personnel_expertise?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
            <!-- Form 9 #line2 -->
            <div v-if="!isFinal" class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ความพร้อมของห้องปฏิบัติการ เครื่องมืออุปกรณ์ทางวิทยาศาสตร์และสิ่งอำนวยความสะดวก
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p9_lab_eqt_readiness?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>

            <!-- Form 9 #line3 -->
            <div v-if="!isFinal" class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  องค์ความรู้พื้นฐานที่จะช่วยสนับสนุนการแก้โจทย์จากภาคเอกชน
                </div>
                <div class="pl-10" v-html="partTwoForm.s2_p9_knowledge_readiness?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <!-- Form 10 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('ten')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              10. ขั้นตอนและขอบเขตการดำเนินโครงการ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <!-- Form 10 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_p10_project_scope_detail?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <!-- Form 11 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('eleven')"
            ></ValidatorIcon>ะ
            <div class="flex xs6 d-flex gap-16">
              <div class="font-type-bold black--text">
                11. หลักการและเหตุผล
              </div>
              <div v-html="partTwoForm.s2_p11_principle?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 12 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partTwoValidate('twelve')"
            ></ValidatorIcon>
            <div class="flex xs6 d-flex gap-16">
              <div class="font-type-bold black--text">
                {{ isFinal ? '4.' : '12.' }} วัตถุประสงค์
              </div>
              <div v-html="partTwoForm.s2_p12_objective?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isFinal" class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <div class="font-type-bold black--text">
              5. ที่มาและความสำคัญ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_source?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isFinal" class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <div class="font-type-bold black--text">
              6. ประเภทอุตสาหกรรม
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_industry_type?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isFinal" class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <div class="font-type-bold black--text">
              7. รูปแบบการเข้าร่วมโครงการเพื่อรับบริการ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_apply_type ? partTwoForm.s2_apply_type.join(', <br>') : ''"></div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div v-if="isFinal" class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <div class="font-type-bold black--text">
              8. ผลการดำเนินงาน
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_overall_result?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isFinal" class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <div class="font-type-bold black--text">
              9. สรุปรายละเอียดแผนการดำเนินงาน / กิจกรรมหลัก
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_summary_operation_detail?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isFinal" class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <div class="font-type-bold black--text">
              10. ความสนใจในการใช้บริการอื่นๆของอุทยานฯในอนาคต
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s2_interest ? partTwoForm.s2_interest.join(', <br>') : ''"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>


    <!--  PART THREE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partThreeValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              1.แผนการดำเนินงานวิจัย (จัดทำในรูปเเบบ Project based management)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 hide-scroll">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 42px; max-width: 42px">
                จัดการ
              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex"
                  style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div class="flex text-center" style="min-width: 43px; max-width: 43px">
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div v-if="partThreeAllPlans && partThreeAllPlans.length > 0" class="d-flex flex-column gap-12">
              <div
                  v-for="(item, i) in partThreeAllPlans"
                  :key="i"
                  class="plan-card d-flex justify-space-between gap-8"
              >
                <div class="flex" style="min-width: 42px; max-width: 42px">

                </div>
                <div class="flex two-line" style="min-width: 120px; max-width: 120px; max-height: 45px">
                  {{ item.p1_activity_name }}
                </div>
                <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px; height: 54px">
                  <v-divider vertical></v-divider>
                  <div class="tiny-field tf-active" style="min-width: 40px; max-width: 40px; height: 100%">
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                    v-for="(m, ind) in item.project_section_plan_month"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                >
                  {{ m.month_value ? m.month_value : '-' }}
                </div>
                <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                  -
                </div>
                <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                  {{ item.percent }}
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card">
                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">

                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                    <v-divider vertical></v-divider>
                    <div class="tiny-field" :class="{ 'theme-color-four tf-error': totalWF() !== '1.00' }" style="min-width: 40px; max-width: 40px">
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex tiny-field"
                      style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">

                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px">
                    </div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex tiny-field"
                      style="min-width: 43px; max-width: 43px"
                  >
                    -
                  </div>
                  <div class="flex" style="min-width: 43px; max-width: 43px">

                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 42px; max-width: 42px">

                  </div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div class="flex d-flex justify-space-between" style="min-width: 61px; max-width: 61px">
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px">
                    </div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex tiny-field"
                      style="min-width: 43px; max-width: 43px"
                  >
                    -
                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                  <div class="flex tiny-field" style="min-width: 43px; max-width: 43px">
                    1.00
                  </div>
                </div>

              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>

          </div>
        </div>

      </div>

      <div class="card-part">
        <div class="mb-5">
          <!--Form 2 budget-->
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partThreeValidate('two')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              2. งบประมาณ (รายละเอียดการประเมินค่าใช้จ่ายในโครงการ)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
            <div style="width: 8%">จัดการ</div>
            <div style="width: 10%">รายการ</div>
            <div style="width: 25%">รายละเอียด</div>
            <div class="text-end" style="width: 10%">In-kind</div>
            <div class="text-end" style="width: 10%">In-cash</div>
            <div class="text-end" style="width: 19%">อุทยานวิทยาศาสตร์</div>
            <div class="text-end" style="width: 18%">รวม</div>
          </div>

          <div class="d-flex flex-column gap-16">
            <div
                v-for="(item, i) in partThreeBudgetList"
                :key="i"
                class="budget-item"
            >
              <div class="d-flex black--text gap-12">
                <div style="width: 8%">
                  <v-btn small icon>
                    <Iconify
                        icon="material-symbols:edit"
                        color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div style="width: 10%">{{ item.budget_name }}</div>
                <div
                    style="width: 25%"
                    v-html="item.budget_detail?.replace(/\n/g, '<br>')"
                ></div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_kind, 2) }}
                </div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_cash, 2) }}
                </div>
                <div class="text-end" style="width: 19%">
                  {{ formatNumber(item.budget_sci_park, 2) }}
                </div>
                <div class="text-end" style="width: 18%">
                  {{ formatNumber(item.budget_sum, 2) }}
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="partThreeBudgetList && partThreeBudgetList.length > 0" class="d-flex flex-column gap-12 px-12 mb-5">
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมลำดับที่ 1-{{ partThreeBudgetList.length }}</div>
            <div class="theme-color-one">{{ formatNumber(partThreeBudgetList.map(x => parseFloat(x.budget_sum)).reduce((a, b) => a + b, 0), 2) }} บาท</div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมงบสนับสนุนโดยภาคเอกชน เป็นเงิน</div>
            <div class="theme-color-one">{{ formatNumber(partThreeBudgetList.map(x => (parseFloat(x.budget_in_kind) + parseFloat(x.budget_in_cash))).reduce((a, b) => a + b, 0), 2) }} บาท</div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมงบสนับสนุนโดยอุทยานวิทยาศาสตร์ เป็นเงิน</div>
            <div class="theme-color-one">{{ formatNumber(partThreeBudgetList.map(x => parseFloat(x.budget_sci_park)).reduce((a, b) => a + b, 0), 2) }} บาท</div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมค่าใช้จ่ายสุทธิ</div>
            <div class="theme-color-one">{{ formatNumber(partThreeBudgetList.map(x => parseFloat(x.budget_sum)).reduce((a, b) => a + b, 0), 2) }} บาท</div>
          </div>
        </div>

      </div>


      <div class="card-part">
        <div>

          <!--Form 3 plan-->
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partThreeValidate('three')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              3. ตารางสรุปแผนการดําเนินงาน
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <!--   HEADERS   -->
          <div class="d-flex px-13 mb-5">
            <div class="flex" style="min-width: 230px; max-width: 230px">
              กิจกรรม
            </div>

            <div class="flex mx-3" style="min-width: 1px; max-width: 1px"></div>

            <div class="d-flex justify-space-between" style="width: 100%">
              <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex"
                  style="min-width: 45px"
              >
                <div class="text-center">{{ m.month }}</div>
                <!--              <div class="text-center">65</div>-->
              </div>
            </div>
          </div>

          <!--   ITEMS   -->
          <div class="d-flex flex-column gap-16">
            <div
                v-for="(item, i) in partThreeAllProgressPlan"
                :key="i"
                class="summary-plan"
            >
              <div class="d-flex black--text">
                <div class="mr-2" style="min-width: 30px; max-width: 30px">

                </div>

                <div class="two-line" style="min-width: 230px; max-width: 230px">
                  {{ item.activity_name }}
                </div>

                <v-divider class="mx-3" vertical style="height: 54px"></v-divider>

                <div class="flex plan-slot d-flex pr-10">
                  <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex"
                      :class="{
                        'progress-plan-mark': item.plan.includes(m.key),
                        'start-point': Math.min.apply(null, item.plan) === m.key,
                        'end-point': Math.max.apply(null, item.plan) === m.key
                      }"
                  >
                    <v-divider v-if="item.plan.includes(m.key)"></v-divider>
                    <div
                        class="white--text arrow-right"
                    >&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div v-if="!isFinal" class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partThreeValidate('four')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              4. รายละเอียดการส่งมอบงาน
              <span class="theme-color-seven txt-normal">(โปรดระบุจำนวนวันส่งรายงานความก้าวหน้าและรายงานฉบับสมบูรณ์ อ้างอิงจากกิจกรรมการดำเนินงาน)</span>
            </div>
          </div>

          <div class="d-flex gap-12 txt-bigger black--text mb-3">
            <div class="flex xs4">แผนการส่งมอบ</div>
            <div class="flex xs2">จำนวนวัน</div>
            <div class="flex xs4">รายละเอียดงานที่ส่งมอบ</div>
            <div class="flex xs2">การเบิกจ่ายเงิน</div>
          </div>


          <div class="d-flex gap-12 mb-5">
            <div class="flex xs4">
              <ul>
                <li>ลงนามในสัญญา</li>
              </ul>
            </div>
            <div class="flex xs2">

            </div>
            <div class="flex xs4">
              <ul>
                <li>ลงแผนการดำเนินโครงการ</li>
              </ul>
            </div>
            <div class="flex xs2">
              <ul>
                <li>งวดที่ 1 (50%)</li>
              </ul>
            </div>
          </div>

          <div class="d-flex gap-12 mb-5">
            <div class="flex xs4">
              <ul>
                <li>
                  ส่งรายงานความก้าวหน้า จำนวน 1 ชุด พร้อมไฟล์
                </li>
              </ul>
            </div>
            <div class="flex xs2">
              <div class="black--text d-flex" style="align-items: center">
                <span class="mr-2">
                ภายใน
                </span>
                <div
                > {{ partTwoForm.s3_p4_progress_day }} วัน</div>
              </div>
              <span class="theme-color-eight flex-1-1-100" style="margin-top: -10px">(นับจากวันที่ลงนามในสัญญา)</span>
            </div>
            <div class="flex xs4">
              <ul>
                <li>
                  <div class="mb-1 black--text">ผลการดำเนินงานตามข้อเสนอโครงการไม่น้อยกว่าร้อยละ 50</div>
                  <div class="d-flex" style="align-items: center">
                    <span class="mr-2">ตามข้อที่</span>
                    <div>{{ partTwoForm.s3_p4_progress_pct }}</div>
                  </div>
                  <div>ในตารางสรุปแผน ดำเนินงาน</div>
                </li>
              </ul>
            </div>
            <div class="flex xs2">
              <ul>
                <li>งวดที่ 2 (30%)</li>
              </ul>
            </div>
          </div>

          <div class="d-flex gap-12">
            <div class="flex xs4">
              <ul>
                <li>
                  ส่งรายงานฉบับสมบูรณ์ จำนวน 1 ชุด พร้อมไฟล์
                </li>
              </ul>
            </div>
            <div class="flex xs2">
              <div class="black--text d-flex" style="align-items: center">
                <span class="mr-2">
                ภายใน
                </span>
                <div>{{ partTwoForm.s3_p4_final_day }} วัน</div>
              </div>
              <span class="theme-color-eight flex-1-1-100" style="margin-top: -10px">(นับจากวันที่ลงนามในสัญญา)</span>
            </div>
            <div class="flex xs4">
              <ul>
                <li>ผลการดำเนินงานตามข้อเสนอ โครงการที่เสร็จสมบูรณ์เรียบร้อย</li>
              </ul>
            </div>
            <div class="flex xs2">
              <ul>
                <li>งวดที่ 3 (20%)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isFinal" class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">4. ปัญหาและอุปสรรคจากการดำเนินงาน</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <div v-html="partTwoForm.s3_problem?.replace(/\n/g, '<br>')"></div>
        </div>
      </div>

      <div v-if="isFinal" class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">5. แนวทางในการแก้ไขปัญหา</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>
          </div>
          <div v-html="partTwoForm.s3_solution?.replace(/\n/g, '<br>')"></div>
        </div>
      </div>
    </divcard>


    <!--  PART FOUR  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> OOI / ตัวชี้วัดความสำเร็จ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partFourValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              ตัวชี้วัดความสำเร็จ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="d-flex flex-column gap-16">
            <!--   OOI   -->
            <div
                v-for="(item, i) in masterData.kpi_masters"
                :key="i"
            >
              <div class="mb-3 black--text txt-bigger">
                ตัวชี้วัดที่ {{ item.no }} {{ item.name }}
              </div>

              <OOILineField
                  v-for="(sub, ind) in item.kpi_sub_masters"
                  :key="ind"
                  :summary="true"
                  :label="sub.name"
                  :unit="sub.unit"
                  :readonly="sub.name === 'รวม'"
                  :field="kpi[sub.id] ? kpi[sub.id].kpi_sub_value : ''"
              ></OOILineField>

            </div>

          </div>

        </div>

      </div>

      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partFourValidate('two')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              ภาระงาน
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">รายชื่อคณะทำงาน</div>
              <div>{{ partTwoForm.s4_p2_name1 }}</div>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">ตำแหน่ง</div>
              <div>{{ partTwoForm.s4_p2_position1 }}</div>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">ภาระงาน (ชั่วโมง/สัปดาห์)</div>
              <div>{{ partTwoForm.s4_p2_work_hrs1 }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex xs4">
            <div class="mb-1 black--text">รายชื่อคณะทำงาน</div>
            <div>{{ partTwoForm.s4_p2_name2 }}</div>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ตำแหน่ง</div>
            <div>{{ partTwoForm.s4_p2_position2 }}</div>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ภาระงาน (ชั่วโมง/สัปดาห์)</div>
            <div>{{ partTwoForm.s4_p2_work_hrs2 }}</div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex xs4">
            <div class="mb-1 black--text">รายชื่อคณะทำงาน</div>
            <div>{{ partTwoForm.s4_p2_name3 }}</div>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ตำแหน่ง</div>
            <div>{{ partTwoForm.s4_p2_position3 }}</div>
          </div>

          <div class="flex xs4">
            <div class="mb-1 black--text">ภาระงาน (ชั่วโมง/สัปดาห์)</div>
            <div>{{ partTwoForm.s4_p2_work_hrs3 }}</div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partFourValidate('three')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              ผลลัพธ์
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <div v-html="partTwoForm.s4_p3_quantity?.replace(/\n/g, '<br>')"></div>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <div v-html="partTwoForm.s4_p3_quality?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partFourValidate('four')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              ประโยชน์ที่ได้รับ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
          </div>

          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงปริมาณ</div>
              <div v-html="partTwoForm.s4_p4_quantity?.replace(/\n/g, '<br>')"></div>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">เชิงคุณภาพ</div>
              <div v-html="partTwoForm.s4_p4_quality?.replace(/\n/g, '<br>')"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex align-center gap-24 mb-3">
          <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="partFourValidate('five')"
          ></ValidatorIcon>
          <div class="font-type-bold black--text">
            การประเมินผลกระทบด้านเศรษฐกิจ
          </div>
        </div>

        <div>
          <div class="d-flex gap-16 mb-5">
            <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
            <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
            <div class="flex txt-bigger text-center">คาดการณ์ผลกระทบที่เกิดขึ้น</div>
          </div>
          <ul>
            <li>
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ยอดขายรายได้เฉลี่ย/การเพิ่มขึ้นยอดขายของผลิตภัณฑ์ กำไร (บาท)
                </div>
                <div class="flex xs3">
                  <div>{{ partTwoForm.s4_p4_revenue }}</div>
                </div>
                <div class="flex">
                  <div>{{ partTwoForm.s4_p4_revenue_desc }}</div>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ต้นทุนการบริการบริหารจัดการ
                  ทรัพยากรในองค์กรค่าใช้จ่ายการ
                  ผลิต ค่าใช้จ่ายอื่นๆ การจ้างงาน(คน)
                  มูลค่าการจ้างงาน(บาท) การลดค่า
                  ใช้จ่าย ลดต้นทุนในการผลิต
                </div>
                <div class="flex xs3">
                  <div>{{ partTwoForm.s4_p4_mgm_cost }}</div>
                </div>
                <div class="flex">
                  <div>{{ partTwoForm.s4_p4_mgm_cost_desc }}</div>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  ประสิทธิภาพ/กำลังการผลิต การ
                  เพิ่มกำลังการผลิต(บาท) มูลค่าของ
                  การเพิ่มประสิทธิภาพหรือคุณภาพ
                  ของผลิตภัณฑ์(บาท)
                </div>
                <div class="flex xs3">
                  <div>{{ partTwoForm.s4_p4_prod_cap }}</div>
                </div>
                <div class="flex">
                  <div>{{ partTwoForm.s4_p4_prod_cap_desc }}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="d-flex gap-16">
                <div style="min-width: 30%; max-width: 30%">
                  การลงทุน มูลค่าการลงทุน R&D
                  (บาท) จำนวนผลิตภัณฑ์ใหม่ที่เสนอ
                  ขายในตลาดต่อปี
                </div>
                <div class="flex xs3">
                  <div>{{ partTwoForm.s4_p4_investment }}</div>
                </div>
                <div class="flex">
                  <div>{{ partTwoForm.s4_p4_investment_desc }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex gap-16 mb-5">
          <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
          <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
          <div class="flex txt-bigger text-center">คาดการณ์ผลกระทบที่เกิดขึ้น</div>
        </div>
        <div class="d-flex gap-16">
          <div style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)">
            การประเมินผลกระทบด้านสังคม
            (จ้างคนในพื้นที่, วัตถุดิบท้องถิ่น)
          </div>
          <div class="flex xs3">
            <div>{{ partTwoForm.s4_p4_social_impact_eval }}</div>
          </div>
          <div class="flex">
            <div>{{ partTwoForm.s4_p4_social_impact_eval_desc }}</div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="d-flex gap-16 mb-5">
          <div style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"></div>
          <div class="flex xs3 txt-bigger text-center">ประมาณมูลค่า (บาท)</div>
          <div class="flex txt-bigger text-center">คาดการณ์ผลกระทบที่เกิดขึ้น</div>
        </div>
        <div class="d-flex gap-16">
          <div style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)">
            การประเมินผลกระทบด้าน
            วิทยาศาสตร์และเทคโนโลยี
            (มีเครื่องจักร, ลิขสิทธิ์, งานวิจัย
            ต่อยอด)
          </div>
          <div class="flex xs3">
            <div>{{ partTwoForm.s4_p4_sci_tech_impact_eval }}</div>
          </div>
          <div class="flex">
            <div>{{ partTwoForm.s4_p4_sci_tech_impact_eval_desc }}</div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview"
                :is-correct="partFourValidate('six')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              หากไม่ได้เข้ารับบริการกับทางอุทยานวิทยาศาสตร์ภูมิภาค จะเกิดผลกระทบ/ผลเสียหายอย่างไร ท่านจะไปใช้บริการกับหน่วยงานใด
            </div>
          </div>

          <div class="indent-info d-flex flex-column gap-8">
            <div class="d-flex gap-16">
              <div class="flex xs6 d-flex gap-16">
                <div v-html="partTwoForm.s4_p5_opinion?.replace(/\n/g, '<br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>


    <!--  PART FIVE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div>
            <span class="theme-color-one">ส่วนที่ 5 :</span> เอกสารแนบ
          </div>

        </div>

        <!-- Form 1 -->
        <div>
          <div class="theme-color-seven mb-3">
            *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 10 mb/ไฟล์)
          </div>

          <div class="d-flex flex-column gap-16">
            <div
                v-for="(item, i) in partFiveAttachment"
                :key="i"
                class="d-flex gap-16"
            >
              <div
                  class="flex"
                  style="max-width: 500px"
              >

              </div>

            </div>
          </div>

        </div>

      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import {eventBus, formatNumber, validateEmail} from "../../../plugins/global-funcs"
import { mapState } from "vuex"
import OOILineField from '../../../components/OOILineField'
import ValidatorIcon from "../../../components/ValidatorIcon"
import {format} from "date-fns";
import {th} from "date-fns/locale";

export default {
  name: "CFormSummary",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      formatNumber,
      private_sum: null,
      inkind_sum: null,
      incash_sum: null,
      scipark_sum: null,
      inkind_percent: null,
      incash_percent: null,
      scipark_percent: null,
      partOneForm: {},
      partTwoForm: {},
      shortMonths: [],
      partThreeForm: {},
      partThreeAllPlans: [],
      partThreeBudgetList: [],
      partThreeAllProgressPlan: [],
      kpi: {},
      partFiveAttachment: []
    }
  },
  computed: {
    ...mapState({
      // GeneralForm: state => state.CForm.GeneralForm,
      // ProjectForm: state => state.CForm.ProjectForm,
      // PlanForm: state => state.CForm.PlanForm,
      // OOIForm: state => state.CForm.OOIForm,
      // AttachmentForm: state => state.CForm.AttachmentForm,
      SummaryData: state => state.CForm.SummaryData
    }),
    isFinal () {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  async created () {
    eventBus.$emit('cFormSummary')
    await new Promise((res, rej) => setTimeout(res, 100))
    // PART ONE
    this.partOneForm = this.masterData.form_c.project_section_general_info
    // PART TWO
    this.partTwoForm = this.masterData.form_c.project_section
    // PART THREE
    this.partThreeAllPlans = this.masterData.form_c.project_section_plan.project_plan_p1 || []
    this.partThreeBudgetList = this.masterData.form_c.project_section_plan.project_section_budget || []
    //this.partThreeAllProgressPlan = this.SummaryData.partThreeAllProgressPlan
    if (this.masterData.form_c) {
      this.form = this.masterData.form_c.project_section;
      for (const x of this.masterData.kpi_masters) {
        for (const y of x.kpi_sub_masters) {
          if (y.kpi_sub_values) {
            let subId = y.kpi_sub_values.kpi_sub_master_id.toString()
            this.kpi[subId] = {}
            this.kpi[subId].id = y.kpi_sub_values.id
            this.kpi[subId].kpi_sub_master_id = y.kpi_sub_values.kpi_sub_master_id
            this.kpi[subId].kpi_sub_value = y.kpi_sub_values.kpi_sub_value
          }
        }
      }
    }
    // PART FIVE
    this.partFiveAttachment = this.masterData.form_c.attachments || []

    this.fiscalYear = this.masterData.form_c.fiscal_year
    this.calculateBudgetProportion();
    this.plotProgressPlanGraphData();
    this.setupBudgetYearMonth();
  },
  methods: {
    totalWF () {
      if (!this.partThreeAllPlans || this.partThreeAllPlans.length === 0) return '-'
      let total = this.partThreeAllPlans.map(x => x.p1_wf).reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      if (typeof total === 'number') return total.toFixed(2)
      return total
    },
    calculateBudgetProportion(){
      let budgetList = this.partThreeBudgetList

      if(budgetList !== undefined && budgetList.length > 0){
        let all_sum = budgetList.map(x => x.budget_sum).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_sum = budgetList.map(x => x.budget_in_kind).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.incash_sum = budgetList.map(x => x.budget_in_cash).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.private_sum = this.inkind_sum + this.incash_sum;
        this.scipark_sum = budgetList.map(x => x.budget_sci_park).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_percent = (this.inkind_sum * 100 / all_sum).toFixed(2)
        this.incash_percent = (this.incash_sum * 100 / all_sum).toFixed(2)
        this.scipark_percent = (this.scipark_sum * 100 / all_sum).toFixed(2)

      }
    },
    plotProgressPlanGraphData() {
      let allPG = [];
      if(this.partThreeAllPlans.length > 0 ){
        this.partThreeAllPlans.forEach((plan) => {
          let PG = {
            activity_name: plan.p1_activity_name,
            plan: []
          }
          if(plan.project_section_plan_month && plan.project_section_plan_month.length > 0){
            let month_plans = [];
            plan.project_section_plan_month.forEach((month, index) => {
              if(month.month_value !== null && parseInt(month.month_value) !== 100)
                month_plans.push(index+1)
            })
            PG.plan = month_plans
          }
          allPG.push(PG)
        })
      }

      console.log('allPG', allPG)
      this.partThreeAllProgressPlan = allPG;
    },
    weightPlan (index) {
      let total = []
      for (const x of this.partThreeAllPlans) {
        let result = x.project_section_plan_month[index] ? parseFloat(x.project_section_plan_month[index].month_value * x.p1_wf) : 0
        if (!isNaN(result)) {
          total.push(result)
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0)
      } else {
        total = '-'
      }
      if (typeof total === 'number') return total.toFixed(2)
      return total
    },
    partTwoValidate (section) {
      let isCorrect = true
      switch (section) {
        case 'one':
          console.log('one', this.partTwoForm.s2_p1_name)
          console.log('two', this.partTwoForm.s2_p2_pm_name)
          if (
              !this.partTwoForm.s2_p1_name ||
              !this.partTwoForm.s2_p1_position ||
              !this.partTwoForm.s2_p1_dep ||
              !this.partTwoForm.s2_p1_org ||
              !this.partTwoForm.s2_p1_addr ||
              !this.partTwoForm.s2_p1_expertise ||
              !this.partTwoForm.s2_p1_resp
          ) { isCorrect = false }

          if (
              !this.partTwoForm.s2_p1_phone ||
              this.partTwoForm.s2_p1_phone.length != 10
          ) { isCorrect = false }

          if (
              !validateEmail(this.partTwoForm.s2_p1_email)
          ) { isCorrect = false }

          return isCorrect


        case 'two':
          if (
              !this.partTwoForm.s2_p2_pm_name ||
              !this.partTwoForm.s2_p2_pm_position ||
              !this.partTwoForm.s2_p2_pm_phone ||
              !this.partTwoForm.s2_p2_pm_email ||
              !this.partTwoForm.s2_p2_proj_coord_name ||
              !this.partTwoForm.s2_p2_proj_coord_position ||
              !this.partTwoForm.s2_p2_proj_coord_phone ||
              !this.partTwoForm.s2_p2_proj_coord_email
          ) { console.log('first', this.partTwoForm.s2_p2_pm_name)
            isCorrect = false }

          if (
              !this.partTwoForm.s2_p2_pm_phone ||
              this.partTwoForm.s2_p2_pm_phone.length != 10 ||
              !this.partTwoForm.s2_p2_proj_coord_phone ||
              this.partTwoForm.s2_p2_proj_coord_phone.length != 10
          ) { console.log('first2')
            isCorrect = false }

          if (
              !validateEmail(this.partTwoForm.s2_p2_pm_email) ||
              !validateEmail(this.partTwoForm.s2_p2_proj_coord_email)
          ) {
            console.log('first3 mail1', this.partTwoForm.s2_p2_pm_email)
            console.log('validate mail1', validateEmail(this.partTwoForm.s2_p2_pm_email))
            console.log('first3 mail2', this.partTwoForm.s2_p2_proj_coord_email)
            console.log('validate mail2', validateEmail(this.partTwoForm.s2_p2_proj_coord_email))
            isCorrect = false }

          return isCorrect

        case 'three':

          if (
              !this.partTwoForm.s2_p3_prv_org_name ||
              !this.partTwoForm.s2_p3_prv_org_address ||
              !this.partTwoForm.s2_p3_prv_org_phone ||
              !this.partTwoForm.s2_p3_prv_org_email ||
              !this.partTwoForm.s2_p3_prv_org_type ||
              !this.partTwoForm.s2_p3_prv_org_trend
          ) { isCorrect = false }

          if (
              !this.partTwoForm.s2_p3_prv_org_phone ||
              this.partTwoForm.s2_p3_prv_org_phone.length != 10
          ) { isCorrect = false }

          if (
              !validateEmail(this.partTwoForm.s2_p3_prv_org_email)
          ) { isCorrect = false }

          return isCorrect

        case 'four':

          if (!this.partTwoForm.s2_p4_prv_org_involved)
          { isCorrect = false }

          return isCorrect

        case 'five':

          if (
              !this.partTwoForm.s2_p5_prv_org_impr_product_quality ||
              !this.partTwoForm.s2_p5_prv_org_impr_process_issue ||
              !this.partTwoForm.s2_p5_prv_org_impr_process_eff ||
              !this.partTwoForm.s2_p5_prv_org_impr_new_product
          ) { isCorrect = false }

          return isCorrect

        case 'six':

          if (
              !this.partTwoForm.s2_p6_prv_org_issue_desc
          ) { isCorrect = false }

          return isCorrect

        case 'seven':

          if (
              !this.partTwoForm.s2_p7_inno_desc
          ) { isCorrect = false }

          return isCorrect

        case 'eight':

          if (
              !this.partTwoForm.s2_p8_prv_org_project_readiness ||
              !this.partTwoForm.s2_p8_prv_org_rnd_readiness ||
              !this.partTwoForm.s2_p8_prv_org_financial_readiness ||
              !this.partTwoForm.s2_p8_prv_org_mgmt_readiness
          ) { isCorrect = false }

          return isCorrect

        case 'nine':

          if (
              !this.partTwoForm.s2_p9_personnel_expertise ||
              !this.partTwoForm.s2_p9_lab_eqt_readiness ||
              !this.partTwoForm.s2_p9_knowledge_readiness
          ) { isCorrect = false }

          return isCorrect

        case 'ten':

          if (
              !this.partTwoForm.s2_p10_project_scope_detail
          ) { isCorrect = false }

          return isCorrect

        case 'eleven':

          if (
              !this.partTwoForm.s2_p11_principle
          ) { isCorrect = false }

          return isCorrect

        case 'twelve':

          if (
              !this.partTwoForm.s2_p12_objective
          ) { isCorrect = false }

          return isCorrect
      }
    },
    partThreeValidate(section){
      let isCorrect = true
      switch (section) {
        case 'one':
          if (
              !this.partThreeAllPlans ||
              this.partThreeAllPlans.length < 1 ||
              this.totalWF() !== '1.00'
          ) { isCorrect = false }

          return isCorrect

        case 'two':
          if (
              !this.partThreeBudgetList ||
              this.partThreeBudgetList.length < 1
          ) { isCorrect = false }

          return isCorrect

        case 'three':
          if (
              !this.partThreeAllProgressPlan ||
              this.partThreeAllProgressPlan.length < 1
          ) { isCorrect = false }

          return isCorrect

        case 'four':
          if (
              !this.partTwoForm.s3_p4_progress_day ||
              !this.partTwoForm.s3_p4_progress_pct ||
              !this.partTwoForm.s3_p4_final_day
          ) { isCorrect = false }

          return isCorrect
      }
    },
    partFourValidate(section){
      let isCorrect = true
      switch(section){
        case 'one':
          //check if kpi_sub_value in each this.kpi is empty
          if(this.kpi.length > 0) {
            this.kpi.forEach((item, index) => {
              if (!item.kpi_sub_value) {
                isCorrect = false
              }
            })
          }

          return isCorrect

        case 'two':
          if (
              !(this.partTwoForm.s4_p2_name1 &&
              this.partTwoForm.s4_p2_position1 &&
              this.partTwoForm.s4_p2_work_hrs1) &&
              !(this.partTwoForm.s4_p2_name2 &&
              this.partTwoForm.s4_p2_position2 &&
              this.partTwoForm.s4_p2_work_hrs2) &&
              !(this.partTwoForm.s4_p2_name3 &&
              this.partTwoForm.s4_p2_position3 &&
              this.partTwoForm.s4_p2_work_hrs3)
          ) { isCorrect = false }

          return isCorrect

        case 'three':
          if (
              !this.partTwoForm.s4_p3_quantity ||
              !this.partTwoForm.s4_p3_quality
          ) { isCorrect = false }

          return isCorrect

        case 'four':
          if (
              !this.partTwoForm.s4_p4_quantity ||
              !this.partTwoForm.s4_p4_quality
          ) { isCorrect = false }

          return isCorrect

        case 'five':
          if (
              !this.partTwoForm.s4_p4_revenue ||
              !this.partTwoForm.s4_p4_revenue_desc ||
              !this.partTwoForm.s4_p4_mgm_cost ||
              !this.partTwoForm.s4_p4_mgm_cost_desc ||
              !this.partTwoForm.s4_p4_prod_cap ||
              !this.partTwoForm.s4_p4_prod_cap_desc ||
              !this.partTwoForm.s4_p4_investment ||
              !this.partTwoForm.s4_p4_investment_desc ||
              !this.partTwoForm.s4_p4_social_impact_eval ||
              !this.partTwoForm.s4_p4_social_impact_eval_desc ||
              !this.partTwoForm.s4_p4_sci_tech_impact_eval ||
              !this.partTwoForm.s4_p4_sci_tech_impact_eval_desc
          ) { isCorrect = false }

          return isCorrect

        case 'six':
          if (
              !this.partTwoForm.s4_p5_opinion
          ) { isCorrect = false }

          return isCorrect
      }
    },
    setupBudgetYearMonth () {
      let ym = new Date((this.fiscalYear - 543).toString() + '-10')
      for (let i = 0; i < 12; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, 'MMM', { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split('-')[0]) + 543).toString().slice(2)
        })
        ym = new Date(ym.setMonth(ym.getMonth() + 1))
      }
    }
  }
}
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #FFFFFF;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #FAFAFA;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #FFFFFF;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}


.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr));
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: 'Tahoma', sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>